'use client'

import { StyledPageLayout } from './pageLayout.styles'

export const PageLayout = (props) => {

  return (
    <StyledPageLayout className="page-wrapper" {...props} />
  )
}
